import Rails from '@rails/ujs'
import './alpine'
import '../controllers/bicycle'
import '../css/bicycle.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
